var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRedeem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C2154",
    d: "M32.981 37.482l.17-.142c.442-.41.655-1.023.564-1.627l-.799-4.902 3.38-3.455c.471-.459.645-1.18.438-1.832l-.063-.155c-.25-.553-.7-.952-1.275-1.07l-4.721-.725-2.077-4.417-.073-.138c-.705-1.202-2.547-1.156-3.161.132l-2.08 4.423-4.613.707c-.691.114-1.23.597-1.435 1.243l-.041.152c-.138.61.046 1.258.5 1.701l3.358 3.434-.796 4.887c-.103.683.155 1.365.719 1.771l.125.088c.517.325 1.213.356 1.787.037l4.093-2.267 4.115 2.269c.232.14.54.223.853.223.362 0 .728-.109 1.032-.337zm-8-11.637l1.998-4.255 2 4.255 4.608.704-3.342 3.418.771 4.73-4.038-2.225-4.026 2.228.773-4.733-3.344-3.419 4.6-.703z",
    transform: "translate(-1052 -263) translate(264 234) translate(784 25)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#1C2154",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 39.157C6.427 37.32 0 29.7 0 20.578 0 11.457 6.427 3.837 15 2M23 2c8.573 1.837 15 9.457 15 18.578 0 9.121-6.427 16.741-15 18.578M22.992 2.001L28.773.395M15 39.157L9.178 40.608",
    transform: "translate(-1052 -263) translate(264 234) translate(784 25) rotate(30 9.15 39.14)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedeem);
export default __webpack_public_path__ + "static/media/icon-redeem.7fba1d3a.svg";
export { ForwardRef as ReactComponent };